
import Vue from 'vue';

export default Vue.extend({
  name: 'm-ModalContent',
  methods: {
    modalContentCloseModal(): void {
      this.$emit('close');
    },
    goTo(where: string): void {
      this.$emit('go-to', where);
    },
  },
  computed: {
    hasFooter() {
      return this.$slots.footer;
    },
  },
});
